/**
 * Mobile country list: put CH, DE, US at top + divider.
 * Only touches form#selector-form--mobile ul#country-list-selector-form--mobile.
 * Standalone – does not modify zimmerli-work.js. Load after theme.
 */
(function() {
    "use strict";
    var TOP = ["CH", "DE", "US"];
    var reorderInProgress = false;

    function run() {
        if (reorderInProgress) return;
        var form = document.getElementById("selector-form--mobile");
        if (!form) return;
        var list = document.getElementById("country-list-selector-form--mobile") || form.querySelector("ul.disclosure-list");
        if (!list || list.getAttribute("data-blz-mobile-reordered") === "1") return;

        var items = list.querySelectorAll("li");
        var withCode = [];
        for (var i = 0; i < items.length; i++) {
            var btn = items[i].querySelector('button[name="country_code"]');
            if (btn && (btn.getAttribute("value") || "").trim().length === 2) withCode.push(items[i]);
        }
        if (withCode.length < 3) return;

        reorderInProgress = true;
        try {
            var topLis = [], restLis = [];
            withCode.forEach(function(li) {
                var code = (li.querySelector('button[name="country_code"]').getAttribute("value") || "").toUpperCase().trim();
                if (TOP.indexOf(code) !== -1) topLis.push(li);
                else restLis.push(li);
            });
            topLis.sort(function(a, b) {
                var va = (a.querySelector('button[name="country_code"]').getAttribute("value") || "").toUpperCase();
                var vb = (b.querySelector('button[name="country_code"]').getAttribute("value") || "").toUpperCase();
                return TOP.indexOf(va) - TOP.indexOf(vb);
            });
            restLis.sort(function(a, b) {
                var ta = (a.querySelector('button[name="country_code"]') && a.querySelector('button[name="country_code"]').textContent) || "";
                var tb = (b.querySelector('button[name="country_code"]') && b.querySelector('button[name="country_code"]').textContent) || "";
                return (ta || "").localeCompare(tb || "");
            });

            var frag = document.createDocumentFragment();
            topLis.forEach(function(li) { frag.appendChild(li); });
            var sep = document.createElement("li");
            sep.className = "disclosure-list__item";
            sep.setAttribute("role", "presentation");
            sep.innerHTML = "<span class=\"disclosure-list__separator\">----</span>";
            sep.style.pointerEvents = "none";
            sep.style.opacity = "0.7";
            sep.style.textAlign = "left";
            frag.appendChild(sep);
            restLis.forEach(function(li) { frag.appendChild(li); });

            while (list.firstChild) list.removeChild(list.firstChild);
            list.appendChild(frag);
            list.setAttribute("data-blz-mobile-reordered", "1");
        } finally {
            reorderInProgress = false;
        }
    }

    run();
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
    setInterval(run, 500);
})();
